// Configuração centralizada da API
// Produção: REACT_APP_BACKEND_URL ou a mesma origem HTTPS (Nginx faz proxy).
// Local: localhost:3001. Rede interna: mesmo host na porta 3001.
const getBackendUrl = () => {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3001';
  }
  if (window.location.protocol === 'https:') {
    return window.location.origin;
  }
  return `http://${window.location.hostname}:3001`;
};

const API_CONFIG = {
  // URL do backend - Detecta automaticamente o IP correto
  BACKEND_URL: getBackendUrl(),
  
  // Endpoints da API (opcional - para organização)
  ENDPOINTS: {
    CONTRATOS: '/api/contratos',
    PRESTADORES: '/api/prestadores',
    FISCAIS: '/api/fiscais',
    AVALIACOES: '/api/avaliacoes',
    ADITIVOS: '/api/aditivos',
    BACKUP: '/api/backup',
    PROCESSO_SERVICO: '/api/processo-servico'
  }
};

export default API_CONFIG;
